module.exports = __webpack_public_path__ + "img/adea350.png";